(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-floating-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gg-floating-reviews'))customElements.define('gg-floating-reviews',class extends HTMLElement{
  connectedCallback(){
    this.onClick=event=>{
      if(event.target.closest('[data-ticker-close]'))this.hidden=true;
      const button=event.target.closest('[data-ticker-pause]');
      if(button){const paused=this.toggleAttribute('data-paused');button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.resume:button.dataset.pause);button.textContent=paused?'▶':'Ⅱ';}
    };
    this.addEventListener('click',this.onClick);
    this.bar=document.querySelector('.gg-bar');
    if(this.bar){this.observer=new ResizeObserver(entries=>document.body.style.setProperty('--gg-purchase-bar-height',`${entries[0].target.getBoundingClientRect().height}px`));this.observer.observe(this.bar);}
  }
  disconnectedCallback(){this.removeEventListener('click',this.onClick);this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-home-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gg-home-slider')) {
  customElements.define('gg-home-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      this.timer = null;

      this.show = n => {
        if (!this.slides.length) return;
        this.index = (n + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          if (active) slide.removeAttribute('aria-hidden'); else slide.setAttribute('aria-hidden', 'true');
          if (active) {
            const img = slide.querySelector('img[loading="lazy"]');
            if (img) img.loading = 'eager';
          }
        });
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
        // Preload the next slide so the fade is smooth
        const next = this.slides[(this.index + 1) % this.slides.length];
        const nextImg = next && next.querySelector('img[loading="lazy"]');
        if (nextImg) nextImg.loading = 'eager';
      };

      this.stop = () => { clearInterval(this.timer); this.timer = null; };

      this.start = () => {
        this.stop();
        if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !document.hidden) {
          this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.delay) || 3000);
        }
      };

      this.select = e => {
        const slide = e.target.closest('[data-slide]');
        if (slide) { this.show(Number(slide.dataset.slide)); this.stop(); }
      };

      this.touch = e => { this.touchX = e.changedTouches[0].clientX; this.stop(); };
      this.swipe = e => {
        const delta = e.changedTouches[0].clientX - this.touchX;
        if (Math.abs(delta) > 40) this.show(this.index + (delta < 0 ? 1 : -1));
        this.start();
      };
      this.visibility = () => (document.hidden ? this.stop() : this.start());

      this.addEventListener('mouseenter', this.stop);
      this.addEventListener('mouseleave', this.start);
      this.addEventListener('shopify:block:select', this.select);
      this.addEventListener('shopify:block:deselect', this.start);
      this.addEventListener('touchstart', this.touch, { passive: true });
      this.addEventListener('touchend', this.swipe, { passive: true });
      document.addEventListener('visibilitychange', this.visibility);

      this.show(0);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.removeEventListener('mouseenter', this.stop);
      this.removeEventListener('mouseleave', this.start);
      this.removeEventListener('shopify:block:select', this.select);
      this.removeEventListener('shopify:block:deselect', this.start);
      this.removeEventListener('touchstart', this.touch);
      this.removeEventListener('touchend', this.swipe);
      document.removeEventListener('visibilitychange', this.visibility);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-product-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gg-purchase-bar')) {
  customElements.define('gg-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.error = this.querySelector('[role="alert"]');
      this.onSubmit = (event) => {
        const source = document.querySelector('.product-information product-form-component form');
        const variant = source?.querySelector('[name="id"]');
        const quantity = source?.querySelector('[name="quantity"]');
        const add = source?.querySelector('[name="add"]');
        if (!source || !variant?.value || add?.disabled || !source.reportValidity()) {
          event.preventDefault();
          if (this.error) this.error.hidden = false;
          source?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.form.elements.id.value = variant.value;
        this.form.elements.quantity.value = quantity?.value || '1';
        if (this.error) this.error.hidden = true;
      };
      this.form?.addEventListener('submit', this.onSubmit);

      this.onPick = (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.name.startsWith('gg_set_')) return;
        const pair = input.value === '2';
        const price = this.querySelector('[data-gg-bar-price]');
        const was = this.querySelector('[data-gg-bar-was]');
        if (price) price.textContent = pair ? this.dataset.pair : this.dataset.single;
        if (was) {
          const text = pair ? this.dataset.pairWas : this.dataset.singleWas;
          was.textContent = text || '';
          was.hidden = !text;
        }
      };
      document.addEventListener('change', this.onPick);
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      document.removeEventListener('change', this.onPick);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
